module.exports = __webpack_public_path__ + "static/media/016.38a363b5.jpg";